import { number, string } from 'prop-types';
import React from 'react';
import { N400 } from '@assets/colors';

const Calendar = ({ color, size }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.83333 2.5C6.29357 2.5 6.66667 2.8731 6.66667 3.33333V4.16667H13.3333V3.33333C13.3333 2.8731 13.7064 2.5 14.1667 2.5C14.6269 2.5 15 2.8731 15 3.33333V4.16667H15.8333C16.7538 4.16667 17.5 4.91286 17.5 5.83333V15.8333C17.5 16.7538 16.7538 17.5 15.8333 17.5H4.16667C3.24619 17.5 2.5 16.7538 2.5 15.8333V5.83333C2.5 4.91286 3.24619 4.16667 4.16667 4.16667H5V3.33333C5 2.8731 5.3731 2.5 5.83333 2.5ZM4.16667 5.83333V7.5H15.8333V5.83333H4.16667ZM15.8333 9.16667H4.16667V15.8333H15.8333V9.16667Z"
      fill={color}
    />
  </svg>
);

Calendar.propTypes = {
  color: string,
  size: number,
};

Calendar.defaultProps = {
  color: N400,
  size: 20,
};

export default Calendar;
